import Request from 'gd-request';

export default class ApiPriorities {

    update(companyId, data) {
        /*
        * data: {
        *   p100: 'Emergency',
        * ...
        *   p5: 'Normal',
        * ...
        *   p1: 'Lowest priority'
        * }
        */
        return new Request(this,'PUT','company/{0}/priorities'.f(companyId),data);
    }
}